import React from "react"
import axios from 'axios'
import settings from '../settings'
import AlertaLogin from '../components/lock/alerta'

const get = async(recurso) => {
  const url   = settings.url + recurso
  const token = sessionStorage.getItem('token')

  // AlertaLogin()

  const client = axios.create({
    headers:{
      authentication: token
    }
  })
  const data = await client.get(url, {token: token})

  if (data.data.erro && data.data.erro =='sim'){
    if (data.data.tipo && data.data.tipo == 'expirado') {
      // alert ('teste expiração login')
      AlertaLogin()
    }
  }

  return data.data
}

const post = async(recurso, dados) => {
  const url = settings.url + recurso

  const token   = sessionStorage.getItem('token')
  const client  = axios.create({
    headers:{
      authentication: token
    }
  })
  const data = await client.post(url, {token: token, dados:dados})

  if (data.data.erro && data.data.erro =='sim'){
    if (data.data.tipo && data.data.tipo == 'expirado') {
      // expiração login
      AlertaLogin()
    }
  }
  
  return data.data
}

const put = async(recurso, dados) => {
  const url     = settings.url + recurso
  const token   = sessionStorage.getItem('token')
  const client  = axios.create({
    headers:{
      authentication: token
    }
  })
  const data = await client.put(url, {token: token, dados:dados})

  if (data.data.erro && data.data.erro =='sim'){
    if (data.data.tipo && data.data.tipo == 'expirado') {
      // expiração login
      AlertaLogin()
    }
  }

  return data.data
}

const del = async(recurso, dados) => {
  const url     = settings.url + recurso
  const token   = sessionStorage.getItem('token')
  const client  = axios.create({
    headers:{
      authentication: token
    }
  })
  const data = await client.delete(url, {token: token})

  if (data.data.erro && data.data.erro =='sim'){
    if (data.data.tipo && data.data.tipo == 'expirado') {
      // expiração login
      AlertaLogin()
    }
  }

  return data.data
}

export default {
  get, post, put, del
}